import { useNavigate } from "react-router-dom";
import styles from "./MyExchange.module.less";
import CommonNavBar from "views/components/CommonNavBar";
import { getExchangeRecord, cancelExchange } from "api/points";
import { useEffect, useState, useRef } from "react";
import { Toast } from "react-vant";
import useScrollLoad from "utils/useScrollLoad";
import PopBox from "../goods-detail/PopBox";

const recordStatus = {
  已发货: "item-status-title--status1",
  已完成: "item-status-title--status2",
  待发货: "item-status-title--status3",
};
const loadingText = {
  nomore: "已经到底啦～",
  loading: "正在加载～",
  empty: "暂无数据",
};
function MyExchange() {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [dataList, setDataList] = useState([]);
  const [popBoxShow, setPopBoxShow] = useState(null);
  const LoadingRef = useRef(null);
  const handleClickGood = (item) => {
    navigate(
      `/mine/logisticsInformation?goods=${encodeURIComponent(
        JSON.stringify(item)
      )}`
    );
  };
  const handleCancel = async (item) => {
    LoadingRef.current = Toast.loading({
      message: "正在取消兑换...",
      forbidClick: true,
      duration: 0,
    });
    const res = await cancelExchange(item.id);
    if (res.code === 200) {
      Toast.info(res.message);
      dataList.find((i) => i.id === item.id).status = "已取消";
      setDataList([...dataList]);
    }
    LoadingRef.current.clear();
  };
  const initData = async () => {
    LoadingRef.current = Toast.loading({
      message: "正在加载数据...",
      forbidClick: true,
      duration: 0,
    });
    setLoading(true);
    const res = await getExchangeRecord(currentPage);
    LoadingRef.current.clear();
    setLoading(false);
    if (res.code === 200) {
      setCurrentPage(currentPage + 1);
      setTotalCount(res.data.total_count);
      setDataList([...dataList, ...res.data.data]);
    }
  };
  const containerRef = useScrollLoad(() => {
    if (dataList.length < totalCount && !loading) {
      initData();
    }
  });
  useEffect(() => {
    initData();
  }, []);
  return (
    <div className={styles["my-exchange-container"]}>
      <CommonNavBar
        onClickBack={() => {
          navigate(-1);
        }}
        title="我的兑换"
      />
      <div className={styles["goods-list"]} ref={containerRef}>
        {dataList.map((item, index) => (
          <div
            className={styles["goods-list-item"]}
            key={`exchange-item-${index}`}
          >
            <div className={styles["item-content"]}>
              <img className={styles["item-content-left"]} src={item.thumb} />
              <div className={styles["item-content-right"]}>
                <div className={styles["right-title"]}>{item.goods_name}</div>
                <div className={styles["right-text"]}>
                  {`创建时间：${item.create_time}`}
                </div>
                <div className={styles["right-text"]}>
                  {`订单编号：${item.order_sn}`}
                </div>
              </div>
            </div>
            <div className={styles["item-status"]}>
              <div
                className={`${styles["item-status-title"]} ${
                  styles[recordStatus[item.status]]
                }`}
              >
                {item.status}
              </div>
              {item.status !== "已取消" ? (
                <div
                  className={`${styles["item-status-button"]} ${
                    item.status === "已下单"
                      ? styles["item-status-button--disabled"]
                      : ""
                  }`}
                  onClick={() => {
                    if (item.status === "已下单") {
                      setPopBoxShow(item);
                    } else {
                      handleClickGood(item);
                    }
                  }}
                >
                  {item.status === "已下单" ? "取消兑换" : "查看物流"}
                </div>
              ) : null}
            </div>
          </div>
        ))}
        <div className={styles["goods-list-bottom"]}>
          {loading ? (
            loadingText["loading"]
          ) : dataList.length === 0 ? (
            <div className={styles["empty-container"]}>
              <img
                className={styles["empty-icon"]}
                src={require("../../../images/image/Ub.png")}
              />
              <div className={styles["empty-text"]}>
                哎呀，您还没有兑换记录呢！快快赚取更多积分，到积分商城兑换精美礼品吧！
              </div>
            </div>
          ) : (
            loadingText["nomore"]
          )}
        </div>
      </div>
      <PopBox
        visible={Boolean(popBoxShow)}
        leftTitle="再想想"
        topTitle="取消兑换"
        content="是否确认取消本次兑换？"
        rightTitle="确认取消"
        bottomOnClick={() => {
          setPopBoxShow(null);
        }}
        leftOnClick={() => {
          setPopBoxShow(null);
        }}
        rightOnClick={() => {
          setPopBoxShow(null);
          handleCancel(popBoxShow);
        }}
      />
    </div>
  );
}

export default MyExchange;
